import http from './httpClient';

const FeatureRequestMS = {
  submitRequest(data: Record<string, unknown>) {
    return http.post(`${import.meta.env.VITE_FEATURE_REQUEST_V0_BASE}/support-requests`, data);
  },
};

export default FeatureRequestMS;
